module.exports = __webpack_public_path__ + "static/media/29BDOS12.5e74241a.jpg";